import React, { useState } from 'react';
import DimensionControls from './components/DimensionControls';
import DieLineCanvas from './components/DieLineCanvas';
import { BoxDimensions } from './types';
import './DieLine.scss';

const DEFAULT_DIMENSIONS: BoxDimensions = {
  length: 315,
  width: 202,
  height: 62,
};

const DieLine: React.FC = () => {
  const [dimensions, setDimensions] =
    useState<BoxDimensions>(DEFAULT_DIMENSIONS);

  return (
    <main className="die-line">
      <DimensionControls dimensions={dimensions} onChange={setDimensions} />
      <DieLineCanvas dimensions={dimensions} />
    </main>
  );
};

export default DieLine;
